<template>
    <div class="">
        <label class="">{{field.name}}</label>
        <div class="">
            <input v-model="config[field.key]" type="checkbox" value="">
            <span v-if="field.memo" :title="field.memo" class="memo" data-tooltip-direction="top" data-tooltip-color="white" data-tooltip-margin="10"></span>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

    /**
     * Created by huangdonglin on 2018/1/3.
     */
    export default {
        name: 'tms-type-boolean',
        props: {
            field: {
                type: [Object, Array],
                required: true
            },
            config: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {}
        },

        components: {},

        mounted() {

        },

        methods: {}
    }

</script>
